import { render, staticRenderFns } from "./UserEmployeeOnboarding.vue?vue&type=template&id=0fbfba4b&"
import script from "./UserEmployeeOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserEmployeeOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports